import { ReactComponent as SearchIcon } from 'assets/icons/search-big.svg'
import NoData from 'components/ui/NoData'
import { getAllTopics, getAllTopicsVariables } from 'graphql/query/__generated__/getAllTopics'
import { GET_ALL_TOPICS } from 'graphql/query/getAllTopics'
import { useEffect, useState } from 'react'

import { useQuery } from '@apollo/client'

import TopicList from '../../Lists/TopicList'

type Props = { search: string }

const initialPagination = {
  take: 50,
  page: 1,
}

function TopicsTab({ search }: Props) {
  const [page, setPage] = useState(initialPagination.page)
  const [loadingNext, setLoadingNext] = useState(false)

  useEffect(() => {
    setPage(initialPagination.page)
  }, [search])

  const { data, loading, fetchMore } = useQuery<getAllTopics, getAllTopicsVariables>(GET_ALL_TOPICS, {
    variables: { title: search, ...initialPagination },
  })

  const onFetchMore = async () => {
    setLoadingNext(true)

    await fetchMore({
      variables: { take: initialPagination.take, page: page + 1 },
      updateQuery(previousQueryResult, { fetchMoreResult }) {
        return {
          ...fetchMoreResult,
          getAllTopics: {
            ...previousQueryResult.getAllTopics,
            ...fetchMoreResult.getAllTopics,
            items: [...previousQueryResult.getAllTopics.items, ...fetchMoreResult.getAllTopics.items],
          },
        }
      },
    })

    setPage((prev) => prev + 1)
    setLoadingNext(false)
  }

  if (!data?.getAllTopics?.items?.length && !loading)
    return (
      <NoData
        height="calc(100% - 82px)"
        icon={<SearchIcon />}
        title="Sorry, we couldn't find any matches"
        description="Try searching again using a different spelling or keyword"
      />
    )

  return (
    <TopicList
      items={data?.getAllTopics?.items}
      next={data?.getAllTopics?.meta?.next}
      onFetchMore={onFetchMore}
      loading={loading}
      loadingNext={loadingNext}
    />
  )
}

export default TopicsTab
